import { useEffect } from 'react';

import { useAccount } from '~/apis';

const SubscriptionReturnHandler = (): JSX.Element | null => {
  const { refetch } = useAccount();

  useEffect(() => {
    // Check if user is returning from Mollie checkout
    if (typeof window !== 'undefined') {
      const urlParams = new URLSearchParams(window.location.search);
      const mollieReturn = urlParams.get('mollie_return');

      if (mollieReturn === 'true') {
        // Start polling for subscription status
        const interval = setInterval(() => {
          refetch();
        }, 2000);

        // Clean up interval when component unmounts
        return () => clearInterval(interval);
      }
    }
  }, [refetch]);

  // This component no longer renders anything visible
  // The processing animation is now handled by the subscription card
  return null;
};

export default SubscriptionReturnHandler;
